import { z } from 'zod';

import { unauthorizedAxiosInstance } from '@/clients';

const notificationUnsubscribeResolutionSchema = z
    .object({
        channel: z.literal('email').optional(),
        expiresAt: z.string().datetime().optional(),
        recipient: z.string().optional(),
        status: z.enum(['expired', 'invalid', 'pending', 'test', 'unavailable', 'unsubscribed']),
        targetName: z.string().optional(),
        valid: z.boolean(),
        workflowKey: z.literal('workspace_alert_triggered').optional(),
        workspaceName: z.string().optional(),
    })
    .strict();

export type NotificationUnsubscribeResolution = z.infer<typeof notificationUnsubscribeResolutionSchema>;

const request = async (path: 'resolve' | 'unsubscribe', token: string) => {
    if (!/^[A-Za-z0-9_-]{43,128}$/.test(token)) {
        return { status: 'invalid', valid: false } satisfies NotificationUnsubscribeResolution;
    }

    const response = await unauthorizedAxiosInstance.post(
        `/auth/notification-unsubscriptions/${path}`,
        { token },
        { suppressErrorCapture: true },
    );

    return notificationUnsubscribeResolutionSchema.parse(response.data);
};

export const resolveNotificationUnsubscribe = (token: string) => request('resolve', token);
export const unsubscribeFromNotification = (token: string) => request('unsubscribe', token);
